module.exports = __webpack_public_path__ + "img/addMoreProduct.51acc70e.svg";